module.exports = __webpack_public_path__ + "img/Retailer_learning_three.24bead15.png";